import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'ppa-pagina-nao-encontrada',
  templateUrl: './pagina-nao-encontrada.component.html',
  styleUrls: ['./pagina-nao-encontrada.component.css']
})
export class PaginaNaoEncontradaComponent implements OnInit {

  @BlockUI() blockUi: NgBlockUI;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  voltar() {
    this.blockUi.start('Redirecionando...');
    setTimeout(() => {
      this.router.navigate(['public']);
      this.blockUi.stop();
    }, 800)
  }
}
